import React from 'react'
import { CssBaseline } from '@maas-components/core'
import {
  createTheme,
  ThemeProvider,
  createGenerateClassName,
  StylesProvider,
} from '@maas-components/styles'
import PropTypes from 'prop-types'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import { CSS_PREFIX } from 'core/common/constants/settings'
import GlobalStyle from 'core/common/styles/global-style'
import WAMuiChipInput from './fixWAMuiChipInput'

const generateClassName = createGenerateClassName({
  seed: CSS_PREFIX,
})

const theme = createTheme({
  overrides: {
    WAMuiChipInput,
    MuiTableCell: {
      root: {
        padding: '16px 4px',
      },
    },
    MuiAutocomplete: {
      tag: {
        '& [class*="MuiChip-label"]': {
          paddingLeft: '8px',
          paddingRight: '8px',
        },
      },
      root: {
        '& [class*="MuiInputLabel-outlined"][class*="MuiInputLabel-shrink"]': {
          transform: 'translate(24px, 4px) scale(0.75)',
        },
      },
      inputRoot: {
        '&[class*="MuiOutlinedInput-root"]': {
          paddingTop: '16px',
          paddingLeft: '24px',
          paddingBottom: '10px',
          '& $input': {
            padding: '0 4px',
          },
          '& $input:first-of-type': {
            paddingLeft: 4,
          },
        },
        '& $tag:first-of-type': {
          marginLeft: 0,
        },
      },
    },
  },
})

const AppTheme = ({ children }) => {
  return (
    <StylesProvider injectFirst generateClassName={generateClassName}>
      <StyledThemeProvider theme={theme}>
        <ThemeProvider withNormalizeCSS theme={theme}>
          <GlobalStyle />
          <CssBaseline />
          {children}
        </ThemeProvider>
      </StyledThemeProvider>
    </StylesProvider>
  )
}

AppTheme.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AppTheme
